import { render, staticRenderFns } from "./banksOpeningBalance.vue?vue&type=template&id=a0fd53ae&scoped=true"
import script from "./banksOpeningBalance.vue?vue&type=script&lang=js"
export * from "./banksOpeningBalance.vue?vue&type=script&lang=js"
import style0 from "./banksOpeningBalance.vue?vue&type=style&index=0&id=a0fd53ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fd53ae",
  null
  
)

export default component.exports